<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { supabase } from '@/supabase'


import Header from '@/components/layout/Header.vue'
import ProgressBar from 'primevue/progressbar'
import Dropdown from 'primevue/dropdown'
import Card from 'primevue/card'

import Instalar from '@/components/Instalar.vue'


const router = useRouter();
const store = useStore()

const user = computed(() => store.state.userSession.user)
const userId = computed(() => store.state.userSession.user.idU)
const loading = computed(() => store.state.loading)
const anosLetivos = ref([])
const anoSelecionado = ref()
const turmasCarregadas = ref(false)
const turmasDadosBrutos = ref([])
const turmas = ref([])
const nomeAluno = ref('');


onMounted(() => {

    if (store.state.anosLetivos != null && store.state.turmasEstudantes != null) {
        anosLetivos.value = store.state.anosLetivos
        turmas.value = store.state.turmasEstudantes
        turmasCarregadas.value = true
        obterAnoAtual()
        return
    }
    carregarDados()

})

async function carregarDados() {
    await listarAnosLetivos()
    obterAnoAtual()
    await carregarNomeAluno();
    await listarTurmas()

}

async function carregarNomeAluno(){
    const {data, error} = await supabase
    .from('users')
    .select('*')
    .eq('id', userId.value)

    if(error){
        console.log(error);
    }

    if(data){
        nomeAluno.value = data[0].nome
    }

    console.log(data);
}

async function listarTurmas() {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('estudantes_turmas')
        .select(`turmas(id)`)
        .eq('idDoEstudante', userId.value)
    let turmaId = data[0].turmas.id
    if (error) {
        alert('Ocorreu um erro ao carregar as turmas' + error)
        store.dispatch('updateLoading', false)
        return
    }

    const { data: aulas, error2 } = await supabase
        .from('aulas')
        .select(`id, turma, cursos!inner(
                            id, anoLetivo, disciplinas (id, nome, area_conhecimento)
                            ))`)
        .eq('cursos.anoLetivo', anoSelecionado.value)
        .eq('turma', turmaId)
        .not('cursos.anoLetivo', 'is', null)

    if (error2) {
        alert('Ocorreu um erro ao carregar as turmas' + error2)
        store.dispatch('updateLoading', false)
        return
    }
    turmasDadosBrutos.value = aulas
    organizarDadosTurmas()
}
const listarAnosLetivos = async () => {
    const { data, error } = await supabase
        .from('anos_letivos')
        .select('id,ano')
    let anos = []
    data.forEach(item => anos.push({ valor: item.id, nome: item.ano }))
    anosLetivos.value = anos

    store.dispatch('updateAnosLetivos', anos)
}

function organizarDadosTurmas() {
    let array = []
    turmasDadosBrutos.value.forEach(aula => {
        array.push({ idDaAula: aula.id, disciplina: aula.cursos.disciplinas.nome, idDisciplina: aula.cursos.disciplinas.id, area_conhecimento: aula.cursos.disciplinas.area_conhecimento })
    })
    array = ordenarListaPorChave(array, 'disciplina')

    turmas.value = array

    store.dispatch('updateTurmasEstudantes', array)

    turmasCarregadas.value = true
    store.dispatch('updateLoading', false)
}


function obterAnoAtual() {
    let dataAtual = new Date()
    anosLetivos.value.forEach(item => {
        if (item.nome == dataAtual.getFullYear()) {
            anoSelecionado.value = item.valor
        }
    })
}

const verAulas = (idDaAula, disciplina, idDisciplina) => {
    let aula = { idDaAula: idDaAula, disciplina: disciplina, idDisciplina: idDisciplina }
   
    store.dispatch('updateAula', aula)
    router.push({
        path: '/estudante/aulas',
    });
};



function definirImagem(disciplina) {
    switch (disciplina) {
        case "Filosofia":
            return require('@/assets/filosofia.jpg')
        case "Sociologia":
            return require('@/assets/sociologia.jpg')
        case "História":
            return require('@/assets/historia.jpg')
        case "Geografia":
            return require('@/assets/geografia.jpg')
        case "Química":
            return require('@/assets/quimica.jpg')
        case "Biologia":
            return require('@/assets/biologia.jpg')
        case "Física":
            return require('@/assets/fisica.jpg')
        case "Matemática":
            return require('@/assets/matematica.jpg')
        case "Português":
            return require('@/assets/portugues.jpg')
        case "Espanhol":
            return require('@/assets/espanhol.jpg')
        case "Inglês":
            return require('@/assets/ingles.jpg')
        case "Teatro":
            return require('@/assets/teatro.jpg')
        case "Música":
            return require('@/assets/musica.jpg')
        case "Educação Física":
            return require('@/assets/educacao_fisica.jpg')
        case "Leitura":
            return require('@/assets/leitura.jpg')
        default:
            return "https://www.gstatic.com/classroom/themes/img_gamenight.jpg"
    }
}


function ordenarListaPorChave(lista, chave) {
    return lista.sort((a, b) => {
        if (a[chave] < b[chave]) {
            return -1;
        }
        if (a[chave] > b[chave]) {
            return 1;
        }
        return 0;
    });
}

function verParecer(){
    router.push({ path: '/estudante/parecer' })
}


</script>


<template>
    <ProgressBar v-if="loading" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
    <div class="surface-50 ">
        <div>
            <Header />
            <div class="container-fluid p-3 sm:p-6 fadein animation-duration-500" v-if="turmasCarregadas == true">
                <div class="flex justify-content-end pt-8 sm:pt-5">
                    <Dropdown @change="listarTurmas" v-model="anoSelecionado" :options="anosLetivos" optionLabel="nome"
                        optionValue="valor" placeholder="Selecione um ano letivo" class="w-full md:w-14rem" />
                </div>

                <Instalar />

                <div v-if="nomeAluno !== ''" class="mb-5">
                    <p class="text-lg">Olá, {{ nomeAluno }} 👋</p>
                </div>

                <!-- <div class="mt-3 mb-4 bg-white card p-5 border-round shadow-1 hover:shadow-2" @click="verParecer">
                    Parecer de Ciências Humanas do 1° tri
                </div> -->
                <div v-if="turmas.length == 0">
                    <div>Não encontramos nenhum disciplina</div>
                </div>
                <div class="grid ">
                    <div class="col-12 md:col-6 lg:col-4" v-for="turma in turmas" :key="turma.idDaAula">
                        <Card @click="verAulas(turma.idDaAula, turma.disciplina, turma.idDisciplina)"
                            class="card h-full shadow-1 hover:shadow-3 animation-duration-1000		">
                            <template #header>
                                <img class="img" alt="user header" :src="definirImagem(turma.disciplina)" />
                            </template>
                            <template #title>
                                <div class="font-semibold text-color text-2xl">{{ turma.disciplina }}</div>
                            </template>

                            <template #content>
                                <div class="text-color text-lg"> {{ turma.area_conhecimento }} </div>
                            </template>
                        </Card>
                    </div>

                </div>
            </div>

        </div>

    </div>
</template>
<style scoped>
.img {
    max-width: 100%;
}

.card {
    cursor: pointer;
}
</style>